(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lumingem-product-assurance"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.lumingem-product-assurance__materials-link');
    if (!link) return;

    const tab = document.querySelector('a[data-block-id="proTabslumingem_cro_care"]');
    const panel = document.getElementById('proTabslumingem_cro_care');
    const tabsContainer = tab?.closest('.product.info.detailed') || panel?.closest('.product.info.detailed');
    if (!tab || !panel || !tabsContainer) return;

    event.preventDefault();
    tab.click();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const stickyHeader = document.getElementById('sticky-header');
        const headerHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
        const top = tabsContainer.getBoundingClientRect().top + window.scrollY - headerHeight - 12;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
